import React from 'react';
import { useTranslation } from 'react-i18next';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';
import * as Styled from '../_styles/ConvoPrep.style';

interface SuggestionItemProps {
  item: {
    title: string;
    short_description: string;
  };
}

export default function SuggestionItem({
  item: suggestion,
}: SuggestionItemProps) {
  const { t } = useTranslation('pageEcoach');

  return (
    <Styled.Content>
      <Text.H5>{suggestion.title}</Text.H5>
      <Text.P2>
        {suggestion.short_description}
        <b style={{ color: colours.blue[500] }}>{t('See more.')}</b>
      </Text.P2>
    </Styled.Content>
  );
}
